// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gG","advertCardList_max6":"c-a_gH"};